export default __webpack_public_path__ + "static/media/mirror.1a49593e.png";